App.SettingsIntegrationsController = Em.Controller.extend
  inappSupport: Em.inject.service('inappSupport')
  organizationBinding: 'model'

  services: [
    {
      type: 'pos',
      items: [ 'r_keeper', 'iiko', 'frontpad', 'sbis' ]
    },
    {
      type: 'aquiring',
      items: [ 'yandex', 'cloud_payments', 'sberbank', 'ibox', 'pay_keeper', 'alfa_bank', 'tinkoff', 'yandex_check' ]
    },
    {
      type: 'delivery_outsource',
      items: [ 'yandex_go', 'dostavista', 'broniboy' ]
    },
    {
      type: 'messaging',
      items: [ 'main_sms', 'smsc', 'megafon', 'infobip', 'whatsapp', 'sms_agent', 'beeline', 'mts', 'sms_aero' ]
    },
    {
      type: 'analytics',
      items: [ 'calltouch' ]
    },
    {
      type: 'loyalty',
      items: [ 'premium_bonus', 'sber_food', 'iiko_card', 'primehill' ]
    },
    {
      type: 'aggregators',
      items: [ 'yandex_eda', 'delivery_club', 'broniboy', 'obed_ru', 'zakazaka', 'chibbis', 'glovo', 'vk', 'sbermarket']
    },
  ]

  services_with_description: ( ->
    @get('services').map((v,i) ->
      ({
        title: Em.I18n.t("settings.integrations.feature.#{v.type}.title"),
        items: (v.items.map((vi, ii) ->
          ({
            title:  Em.I18n.t("settings.integrations.feature.#{v.type}.#{vi}.title"),
            description:  Em.I18n.t("settings.integrations.feature.#{v.type}.#{vi}.description")
          })
        ))
      })
    )
  ).property('services')


  actions:
    connectService: (service) ->
      @get('inappSupport').initiateDialogue("Добрый день!\nМы хотим подключить Интеграцию с #{service}. \nРасскажите, как это сделать, пожалуйста.")
      return false
